/*
 * NOTE: this reducer is being deprecated in favour of productDetailPage - see product-detail-page.js
 */

import { parse } from "query-string";

// DETERMINE DEFAULT ITEM LIST & SALE PRICES
const getPrice = (product) => {
  if (!product["child-skus"]) return;

  let highRetail = false;
  let lowRetail = false;
  let highSale = false;
  let lowSale = false;
  let sale = false;
  const currency =
    product["child-skus"][0]["price-details"]["currency-symbol"] ?? "";
  let listPrice = parseFloat(
    product["child-skus"][0]["price-details"]["list-price"] ?? ""
  ).toFixed(2);
  const listPriceNum = parseFloat(listPrice);
  let salePrice = false;

  product["child-skus"]?.map((item) => {
    const childPrice = item["price-details"];
    const childRetailPrice = parseFloat(childPrice["list-price"]).toFixed(2);
    const childRetailPriceNum = parseFloat(childRetailPrice);

    if (childRetailPriceNum > listPriceNum) highRetail = childRetailPrice;
    if (childRetailPriceNum < listPriceNum) lowRetail = childRetailPrice;

    // IF THERE'S A SALE
    if (childPrice["on-sale"]) {
      const childSalePrice = parseFloat(childPrice["sale-price"]).toFixed(2);
      const childSalePriceNum = parseFloat(childSalePrice);
      sale = true;

      if (!salePrice) salePrice = childSalePrice;
      const salePriceNum = parseFloat(salePrice);

      if (childSalePriceNum === salePriceNum) highSale = childSalePrice;
      if (childSalePriceNum > salePriceNum) highSale = childSalePrice;
      if (childSalePriceNum < salePriceNum) lowSale = childSalePrice;
    }
  });

  // DETERMINE HIGH/LOW RETAIL PRICES
  if (highRetail && lowRetail) {
    listPrice = `${highRetail} - ${highRetail}`;
  } else if (highRetail && highRetail > listPrice) {
    listPrice = `${listPrice} - ${highRetail}`;
  } else if (lowRetail && lowRetail < listPrice) {
    listPrice = `${lowRetail} - ${listPrice}`;
  } else if (highRetail && highRetail < listPrice) {
    listPrice = `${highRetail} - ${listPrice}`;
  } else if (lowRetail && lowRetail > listPrice) {
    listPrice = `${listPrice} - ${lowRetail}`;
  }

  // DETERMINE HIGH/LOW SALE PRICES
  if (highSale && lowSale) {
    salePrice = `${lowSale} - ${highSale}`;
  } else if (highSale && highSale > salePrice) {
    salePrice = `${salePrice} - ${highSale}`;
  } else if (lowSale && lowSale < salePrice) {
    salePrice = `${lowSale} - ${salePrice}`;
  } else if (highSale && highSale < salePrice) {
    salePrice = `${highSale} - ${salePrice}`;
  } else if (lowSale && lowSale > salePrice) {
    salePrice = `${salePrice} - ${lowRetail}`;
  }

  return {
    currency,
    listPrice,
    salePrice,
    sale,
  };
};

// eslint-disable-next-line import/prefer-default-export
export function setProduct(productData, queryString) {
  const data = { ...(productData?.data ?? productData) };
  const urlStyleColorParam = parse(queryString)
    ?.color?.split(/[- _]+/, 2)
    .join("");
  // DETERMINE AVAILABLE PRODUCT COLORS
  const activeSwatch = getActiveSwatch(data, urlStyleColorParam);

  const selectedSku = data?.["child-skus"]?.find((sku) => {
    // remove spaces from size name for comparison
    const skuSize = sku?.size?.split(" ").join("");

    // get an array of filtered sizes from the query string
    const sizes = parse(queryString).sz?.split(",") ?? [];

    // find the first filtered size that exists for this product
    const filteredSize = sizes.find((size) => size === skuSize);

    if (
      sku["color-code"] === activeSwatch["color-code"] &&
      skuSize === filteredSize
    ) {
      return true;
    }
  });

  // DETERMINE DEFAULT PRICE
  data.price = getPrice(data);

  // SET DEFAULT SKU
  data.selectedItem = {
    carousel: activeSwatch,
    swatch: activeSwatch,
    sku: selectedSku,
  };

  // IF THERE IS A SELECTED SKU, USE THE PRICE FOR THAT SKU INSTEAD
  if (data.selectedItem.sku && data.selectedItem.sku.id) {
    const price = data.selectedItem.sku["price-details"];

    data.price = {
      currency: price["currency-symbol"],
      listPrice: price["list-price"],
      salePrice: price["sale-price"],
      sale: price["on-sale"],
    };
  }

  return data;
}

const getActiveSwatch = (productData, urlStyleColorParam) => {
  if (!productData["child-skus"]) return;

  const purchaseAttrs = productData["purchase-attributes"];

  const selectedIndex = purchaseAttrs["selected-swatch-index"] ?? 0;
  const colorDriver = purchaseAttrs["color-driver"] ?? [];
  // FIND AVAILABLE COLORS FROM COLOR DRIVER
  const availableColors = colorDriver.map(({ color }) => color);

  const skuParam = productData?.["child-skus"]?.find(
    (sku) => sku["style-id"].split(/[- _]+/, 2).join("") === urlStyleColorParam
  );

  const defaultSwatch =
    productData["product-carousel"].find((swatch) =>
      availableColors?.includes(swatch["color-code"])
    ) ?? productData["product-carousel"][selectedIndex];

  // DETERMINE AVAILABLE PRODUCT COLORS
  const activeSwatch = productData["product-carousel"].find((swatch) => {
    // IF STYLE ID IS AVAILABLE FROM ACTIVE SKU
    if (skuParam?.["color-code"] === swatch["color-code"]) return true;

    // IF ONLY COLOR IS IN URL
    if (urlStyleColorParam === swatch["color-code"]) return true;
  });

  return activeSwatch ?? defaultSwatch;
};
